var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.71973 11.6792C11.0736 10.9953 13.6952 8.12104 15.2797 5.19922C17.3578 7.34732 20.8283 9.40362 24.0527 9.40362C26.0983 9.40362 28.0185 8.86565 29.6797 7.92424",
    stroke: "#B7CCFF",
    strokeWidth: 1.14285,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8394 23.9184C33.8517 23.7034 35.4394 21.2068 35.4394 18.1587C35.4394 15.1101 33.8517 12.6134 31.8394 12.3984V23.9184Z",
    fill: "#FF8165"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2395 33.2773C20.2335 33.2773 21.0395 34.0833 21.0395 35.0774C21.0395 36.0714 20.2335 36.8773 19.2395 36.8773C18.2454 36.8773 17.4395 36.0714 17.4395 35.0774C17.4395 34.0833 18.2454 33.2773 19.2395 33.2773Z",
    fill: "#A020FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0277 34.4334C24.3114 34.0925 26.6251 33.2936 28.1805 31.7353C30.1123 29.8005 31.6175 26.5199 31.6175 23.5857V13.6025C31.6175 10.6683 30.1123 7.69336 28.1805 5.75886C26.249 3.82374 23.2784 2.31641 20.3488 2.31641H18.887C15.9573 2.31641 12.9871 3.82374 11.0556 5.75886C9.12385 7.69336 7.71973 9.46218 7.71973 12.3964",
    stroke: "#081E54",
    strokeWidth: 1.14285,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.98663 23.7756C5.22124 23.5633 3.03955 21.0976 3.03955 18.0873C3.03955 15.0765 5.22124 12.6108 7.98663 12.3984V23.7756Z",
    stroke: "#081E54",
    strokeWidth: 1.14285,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8394 23.7756C34.6048 23.5633 36.7864 21.0976 36.7864 18.0873C36.7864 15.0765 34.6048 12.6108 31.8394 12.3984V23.7756Z",
    stroke: "#081E54",
    strokeWidth: 1.14285,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6013 32.0391C20.9347 32.0391 22.016 33.122 22.016 34.4576C22.016 35.7932 20.9347 36.8761 19.6013 36.8761C18.2677 36.8761 17.1865 35.7932 17.1865 34.4576C17.1865 33.122 18.2677 32.0391 19.6013 32.0391Z",
    stroke: "#081E54",
    strokeWidth: 1.14285,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40527 12.6637C10.9448 11.9412 13.9205 9.66512 15.5927 6.57812C17.7858 8.84766 20.8593 10.2595 24.2621 10.2595C26.4209 10.2595 28.4473 9.69113 30.2005 8.6965",
    stroke: "#081E54",
    strokeWidth: 1.14285,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/Contact.6ae7e14a5367217e0b7d87836cbd8b82.svg";
export { ForwardRef as ReactComponent };